export default class PointOfSalesController {
  constructor($state, $uibModal,ContentService, isMobile) {
    this.modal = $uibModal;
    this.$state = $state;
    this.service = ContentService;
    this.isMobile = isMobile;
  }

  $onInit() {
    this.subscriptions = [];

    this.inMobileView = this.isMobile.phone;
    this.subscriptions.push(
      this.posObservable.subscribe(posList => this.posList = posList)
    );
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  openPOSModal(pointOfSales){
    var that = this;
    this.modal.open({
      animation: true,
      size: 'lg',
      templateUrl: 'new-pos-template.html',
      appendClassName: 'ngdialog-theme-plain',
      controller: ($scope, $state, $uibModalInstance) => {
        "ngInject";
        $scope.pointOfSales = pointOfSales || {};
        $scope.closeThisDialog = () => $uibModalInstance.close();
        $scope.registerPOS = () => {
          that.subscriptions.push(
            that.service.registerPOS($scope.pointOfSales).subscribe(
              (newPOS) => {
                that.posList.push(newPOS);
                $scope.closeThisDialog();
              },
              (error) => {
                console.log(error);
              }
            )
          );
        }
        $scope.editPOS = () => {
          that.subscriptions.push(
            that.service.changePOS($scope.pointOfSales).subscribe(
              (resp) => {
                $scope.closeThisDialog();
              },
              (error) => {
                console.log(error);
              }
            )
          );
        }
      }
    })
  }

  deletePos(pos){
    this.subscriptions.push(
      this.service.deletePOS(pos.id).subscribe(
        (resp) => {
          this.posList.splice(this.posList.indexOf(pos), 1);
        },
        (error) => {
          console.log(error);
        }
      )
    );
  }

}

 PointOfSalesController.$inject = ['$state', '$uibModal', 'ContentService', 'isMobile'];


// WEBPACK FOOTER //
// ./src/app/pages/point-of-sales/point-of-sales.controller.js